{
    "accept": "Aceptar",
    "action_open_in_external_app": "Abrir en ${1}",
    "all": "Todo",
    "apply": "Aplicar",
    "back": "Atrás",
    "cancel": "Cancelar",
    "choose": "Elegir",
    "clear": "Limpiar",
    "clear_all": "Limpiar todo",
    "clear_filters": "Limpiar filtros",
    "client_offline_error_description": "Estás sin conexión. Por favor, comprueba tu conexión a Internet e inténtalo de nuevo.",
    "client_offline_error_title": "Sin conexión a Internet",
    "client_timeout_error_description": "No pudimos completar tu solicitud debido a un tiempo de espera agotado en la conexión. Por favor, comprueba tu conexión e inténtalo de nuevo. Si el problema persiste, nuestro equipo de soporte está aquí para ayudarte.",
    "client_timeout_error_title": "Tiempo de espera agotado para la conexión.",
    "content_missing": "Falta el contenido.",
    "delete": "Eliminar",
    "description": "Descripción",
    "dismiss": "Descartar",
    "done": "Hecho",
    "donor_feedback_anonymized": "Ya anonimizamos tus datos por motivos de protección de datos.",
    "donor_feedback_incorrect_link": "El enlace que estás utilizando no es correcto; por favor, asegúrate de utilizar el enlace completo que se te envió.",
    "donor_feedback_not_found": "Lamentablemente, este enlace no es válido; esto puede deberse a una de las siguientes razones:",
    "error_occurred": "Ocurrió un error",
    "expired": "Caducado",
    "failed": "Suspendido",
    "field_address_search_accuracy_hint": "Mejora los resultados de búsqueda concediendo a la aplicación acceso a tu ubicación a través de los ajustes del sistema operativo.",
    "field_error_address_unsupported_country": "La dirección no está en un país aceptado",
    "field_error_any": "Por favor, proporciona al menos uno de estos campos: ${1}",
    "field_error_date_invalid": "Por favor, proporciona una fecha válida",
    "field_error_date_max": "La fecha debe ser ${1} o anterior",
    "field_error_date_min": "La fecha debe ser ${1} o posterior",
    "field_error_date_range_max": "La fecha debe ser anterior a ${1}",
    "field_error_date_range_min": "La fecha debe ser posterior a ${1}",
    "field_error_email": "Por favor, proporciona un correo electrónico válido",
    "field_error_length_max": "Este campo está restringido a ${1} caracteres",
    "field_error_length_min": "Por favor, proporciona un mínimo de ${1} caracteres",
    "field_error_max": "El valor máximo es ${1}",
    "field_error_min": "El valor mínimo es ${1}",
    "field_error_pattern": "La entrada no es válida",
    "field_error_phone_invalid": "Por favor, proporciona un número de teléfono válido",
    "field_error_phone_starts_with_zero": "Ya existe un código de país. Por favor, elimina el \"0\" inicial del número de teléfono.",
    "field_error_required": "Por favor, rellena este campo",
    "field_is_required": "Este campo es obligatorio",
    "field_placeholder_address_search": "Introduce una ubicación",
    "field_select_not_found": "No se pudo encontrar '${1}'",
    "font_big": "fuente grande",
    "font_medium": "fuente mediana",
    "font_small": "fuente pequeña",
    "last_attempt": "Último intento",
    "last_upload": "Última carga",
    "link_sent": "Enlace enviado, por favor comprueba",
    "network_error": "Error de red",
    "network_error_cookies_disabled_description": "¿Parece que has desactivado todas las cookies? Tal vez intenta con otro navegador",
    "network_error_cookies_disabled_title": "Cookies desactivadas",
    "next": "Siguiente",
    "no_results": "Sin resultados",
    "offline": "sin conexión",
    "ok": "Aceptar",
    "online": "en línea",
    "open": "Abrir",
    "page_not_found_description": "La página que intentaste solicitar no existe. Es posible que hayas escrito mal la URL.",
    "page_not_found_link": "Volver a la página principal.",
    "page_not_found_title": "Página no encontrada",
    "pagination_result": "${1} - ${2} de${3} resultados",
    "passed": "Aprobado",
    "request_support": "Solicitar soporte",
    "request_support_error_title": "Solicitud fallida",
    "request_support_success_description": "Hemos recibido tu solicitud de soporte.",
    "request_support_success_title": "Solicitud recibida",
    "reset_filters_description": "Intenta ajustar tu búsqueda o filtros.",
    "result": "Resultado",
    "retry": "Reintentar",
    "save": "Guardar",
    "select_group_selected": "Seleccionado",
    "send_a_support_request": "Solicitud de soporte",
    "server_unavailable_error_description": "El servicio no está disponible temporalmente. Por favor, vuelve a comprobarlo más tarde.",
    "server_unavailable_error_title": "Servicio no disponible",
    "server_unexpected_error_description": "Algo salió mal por nuestra parte. Por favor, inténtalo de nuevo en un momento. Si el problema persiste, ponte en contacto con nuestro servicio de soporte.",
    "server_unexpected_error_title": "Ocurrió un error inesperado.",
    "state_done": "Hecho",
    "state_not_uploaded": "No subido",
    "state_pending": "Pendiente",
    "state_refused": "Rechazado",
    "state_uploading": "Subiendo",
    "submit": "Enviar",
    "support_request_type": "Tipo",
    "support_request_type_crash": "Crash",
    "support_request_type_critical": "Crítico",
    "support_request_type_minor": "Menor",
    "support_request_type_other": "Otro",
    "toggle_detail_view": "Vista detallada",
    "toggle_list_view": "Vista de lista",
    "type": "Tipo",
    "unknown_error": "Algo salió mal",
    "unknown_error_description": "Ocurrió un error inesperado. Por favor, inténtalo de nuevo. Si el problema persiste, ponte en contacto con el soporte.",
    "uploading": "Cargando...",
    "validating": "Espera un momento, nos estamos asegurando de que todo esté correcto..."
}